import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Trash2 } from "lucide-react";
import { useAdminApi, downloadCsv } from "./useAdminApi";

const TYPES = [["", "All"], ["club_registration", "Poetry Club registrations"], ["performer_application", "Performer applications"], ["vendor_application", "Vendor applications"], ["volunteer", "Volunteers"], ["newsletter", "Newsletter"]];

export default function AdminSubmissions() {
  const api = useAdminApi();
  const [type, setType] = useState("");
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api("get", `/admin/submissions${type ? `?type=${type}` : ""}`).then(setRows), [api, type]);
  useEffect(() => {
    load();
  }, [load]);

  const setStatus = async (id, status) => {
    await api("patch", `/admin/submissions/${id}`, { status });
    toast.success("Status updated");
    load();
  };
  const remove = async (id) => {
    if (!window.confirm("Delete this submission?")) return;
    await api("delete", `/admin/submissions/${id}`);
    load();
  };

  return (
    <div data-testid="admin-submissions">
      <div className="flex flex-wrap gap-3 mb-5">
        <select className="field !w-auto" value={type} onChange={(e) => setType(e.target.value)} data-testid="admin-submissions-type-filter">
          {TYPES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <button onClick={() => downloadCsv(api, "submissions")} className="btn-ink !py-2 ml-auto" data-testid="admin-export-submissions-button"><Download className="w-4 h-4" />Export CSV</button>
      </div>
      <div className="space-y-3">
        {rows?.length === 0 && <p className="text-mas-mute text-sm">No submissions yet.</p>}
        {rows?.map((r) => (
          <div key={r.id} className="bg-white border-2 border-mas-ink p-4 grid md:grid-cols-[1fr_auto] gap-4" data-testid={`admin-submission-${r.id}`}>
            <div className="min-w-0">
              <p className="font-mono text-[10px] uppercase tracking-wider text-mas-terra">{r.type.replace("_", " ")} · {r.created_at.slice(0, 10)}</p>
              <p className="font-semibold mt-1">{r.name || "—"} <span className="font-normal text-mas-mute text-sm">{r.email} {r.phone && `· ${r.phone}`}</span></p>
              {Object.entries(r.details || {}).filter(([, v]) => v).map(([k, v]) => <p key={k} className="text-sm"><span className="text-mas-mute capitalize">{k.replace("_", " ")}:</span> {v}</p>)}
              {r.message && <p className="text-sm mt-1 italic whitespace-pre-line">{r.message}</p>}
            </div>
            <div className="flex md:flex-col gap-2 items-start">
              <select className="field !py-1 !text-xs" value={r.status} onChange={(e) => setStatus(r.id, e.target.value)} data-testid={`admin-submission-status-${r.id}`}>
                {["new", "reviewed", "accepted", "declined"].map((s) => <option key={s}>{s}</option>)}
              </select>
              <button onClick={() => remove(r.id)} className="p-2 text-mas-terra" data-testid={`admin-submission-delete-${r.id}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
